export { default } from './ScrollEntrance'
